module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/result/thum02-b0c877fb6611c8b01e22112658a61410.png";